export default __webpack_public_path__ + "40e15a3632405314d7b2c529e7d6ed12.jpg";